import moment from "moment";

function PostDateElement({post}){
    const style = {
        fontSize: 12,
        color: "#666"
    }
    return <a rel="noreferrer" style={style} href={post.full_uri} target="_blank">{moment(1000 * post.post_timestamp).format("LLL")}</a>
}
export default PostDateElement;